export default "__VITE_ASSET__BE8aTsjw__"